import React, { CSSProperties, Component } from 'react'

import { RandomProduct } from "shape-edit/types";

import {
    getShapeSize,
    getTemplateGradientAndBackground,
    getTemplateSize,
    replaceDynamicTextWithProductData,
} from "shape-edit/forms/helpers";

import { GradientDefs, GradientFillUrl } from "shape-edit/forms/fields";
import { TemplateGalleryType } from "../components/template-gallery";
import { getShapeByType } from "../components/helper";
import { URL } from "app/config/api-config";
import trans, { isTrans } from "trans";
import SourceImageSvgElements from "shape-entities/components/source-image-svg-elements";
import { SOURCE_IMAGE_TYPE } from 'shape-entities/types/shape';
import { SHAPE_ID_PREFIX } from './image-preview';
import sortBy from 'lodash/sortBy';
import { map } from 'lodash';

interface Props {
    isAlt: boolean
    templateGallery: TemplateGalleryType
    randomProduct: RandomProduct
    style?: CSSProperties
}

const {round, tan, PI} = Math

class PreviewTemplateSVG extends Component<Props> {
    constructor(props) {
        super(props)
    }

    render() {
        const { randomProduct, templateGallery, style, isAlt } = this.props

        if (!templateGallery || !randomProduct) {
            return false
        }

        const templateForm = JSON.parse(templateGallery.serialized_template)

        if (!templateForm) {
            console.error('Cannot load template gallery from', templateGallery.id)
            return false
        }

        const shapesWithTextReplaced = replaceDynamicTextWithProductData(templateForm, randomProduct)
        //const shapesWithTextReplaced = templateForm.shapes

        const s = 180

        let hasSourceImageLayer = false
        const sorted = sortBy(shapesWithTextReplaced, [(shape) => {
            if (shape.type === SOURCE_IMAGE_TYPE) {
                hasSourceImageLayer = true
            }
            return new Number(-shape.priority)
        }]).filter(shape => (shape.is_hidden !== 1))

        const size = getTemplateSize(templateForm)

        const screenWidth = size.width
        const screenHeight = size.height

        const sourceImageLayer = <g>
            <SourceImageSvgElements
                isTemplatePreview={true}
                isDraggable={false}
                isAlt={isAlt}
                randomProduct={randomProduct}
                form={templateForm}
                collageLayout={templateForm.collage_layout}
                transX={0}
                transY={0}
            />
        </g>

        const { templateBackgroundColor, templateGradient } = getTemplateGradientAndBackground(templateForm, randomProduct, templateForm.gradient ? [templateForm.gradient] : [])

        const defaultStyle: CSSProperties = {
            width: 'auto',
            height: 'auto',
            maxWidth: '100%',
            maxHeight: `${s}px`,
            border: '1px solid #80808033'
        }

        return (
            <svg
                viewBox={`0 0 ${screenWidth} ${screenHeight}`}
                width={`${screenWidth}px`}
                height={`${screenHeight}px`}
                preserveAspectRatio={'xMidYMid meet'}
                style={style ?? defaultStyle}
            >

                <defs id="google-fonts" />

                {templateGradient &&
                    <GradientDefs gradient={templateGradient} idx={templateGradient.id} />
                }

                <rect
                    className={'preview-background'}
                    id={'preview-background-canvas'}
                    width={screenWidth}
                    height={screenHeight}
                    fill={templateGradient ? GradientFillUrl(templateGradient.id) : templateBackgroundColor}
                    fillOpacity={templateGradient && templateGradient.opacity ? templateGradient.opacity / 100 : 1}
                />

                {!hasSourceImageLayer && sourceImageLayer}

                {map(sorted, (shape) => {
                    const flip = (shape.is_flip ? -1 : 1)
                    const flop = (shape.is_flop ? -1 : 1)
                    const scale = shape.scale ? shape.scale : 1

                    const { width, height } = getShapeSize(shape)

                    const translateReflection = shape.reflection_flip ? -shape.reflection_offset : (height + shape.reflection_offset)

                    const shapeWithImageBlob = {
                        ...shape,
                        imageBlob: shape.imageBlob ? shape.imageBlob.replace('/www/www', URL.laravelBase) : shape.imageBlob,
                        text_content: shape.text_content && isTrans(shape.text_content) ? trans(shape.text_content) : shape.text_content
                    }

                    const shapeOpacity = shape.opacity && shape.opacity > 0 && shape.opacity < 100 ? shape.opacity / 100 : undefined
                    const reflectionAngle = round(shape.reflection_angle || 0)

                    return <g key={`i${shape.index}`} className={`${shape.type}${shape.index}`} style={{ opacity: shapeOpacity }}>
                        {shape.type === SOURCE_IMAGE_TYPE && randomProduct && randomProduct.isLoaded ? sourceImageLayer :
                            <g transform={`translate(${shape.x}, ${shape.y})`}>
                                <g transform={`rotate(${shape.angle || 0}), scale(${flop * scale}, ${flip * scale})`} id={`${SHAPE_ID_PREFIX}${shape.index}`}>
                                    {shape.has_reflection &&
                                        <React.Fragment>
                                            <defs>
                                                <linearGradient id={`gradient-${shape.index}`} y1="0%" y2="100%">
                                                    <stop offset="0%" stopColor="black" stopOpacity=".9" />
                                                    <stop offset="100%" stopColor="white" stopOpacity={`1`} />
                                                </linearGradient>
                                                <mask id={`gradient-mask-${shape.index}`}>
                                                    <rect x={-width / 2} y={-height / 2} width={width} height={height} fill={`url(#gradient-${shape.index})`} />
                                                </mask>
                                            </defs>
                                            <g className={'shape-reflection'}
                                                transform={`translate(0, ${translateReflection}), scale(1,${shape.reflection_flip ? 1 : -1}), skewX(${reflectionAngle}), translate(${-round(tan(PI * reflectionAngle / 180) * .5 * height)},0)`}
                                                mask={`url(#gradient-mask-${shape.index})`}
                                                style={{ opacity: 1 - ((shape.reflection_opacity||0) / 100) }}>
                                                {getShapeByType(shape, size, false, null, null)}
                                            </g>
                                        </React.Fragment>

                                    }
                                    {getShapeByType(shapeWithImageBlob, size, false, null, null)}
                                </g>
                            </g>
                        }
                    </g>
                })}
            </svg>
        )
    }
}

export default PreviewTemplateSVG
